import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Image,
    Text
} from "@chakra-ui/react";

const ImagePreviewModal = ({ isOpen, onClose, selectedImage }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Slika zadatka</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {selectedImage ? (
                        <Image src={selectedImage} alt="Ticket Preview" maxW="100%" />
                    ) : (
                        <Text>Slika nije učitana.</Text>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ImagePreviewModal;
